import { render, staticRenderFns } from "./four.vue?vue&type=template&id=3400077c&scoped=true&"
var script = {}
import style0 from "./four.vue?vue&type=style&index=0&id=3400077c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3400077c",
  null
  
)

export default component.exports